<template>
    <v-card class="pa-2">
        <v-container class="text-center" >
            <div class="mb-6">
                <h3 class="my-2">
                    ¿Quieres saber sobre el proceso de prácticas?
                </h3>
                <v-btn
                    elevation="0"
                    class="mr-4"
                    color="primary"
                    @click="info_proceso_url()"
                    >Revisar proceso</v-btn
                >
            </div>
            
            <div class="mb-6">
                <h3 class="mt-2 mb-2">
                    Revisa las preguntas frecuentes si tienes dudas
                </h3>
                <v-btn
                    elevation="0"
                    class="mr-4"
                    color="primary"
                    @click="preguntas_url()"
                    >Preguntas Frecuentes</v-btn
                >
            </div>
        

            <h3 class="mt-5 mb-2">Revisa la charla de prácticas</h3>

            <div v-if="videoUrl" class="video-responsive mb-3" >
                <iframe
                    :src="videoUrl"
                    frameborder="0"
                    allowfullscreen
                ></iframe>
            </div>
            <v-btn
                v-if="presentacionUrl"
                elevation="0"
                class="mr-2"
                color="primary"
                target="_blank"
                rel="noopener noreferrer"
                :href="presentacionUrl"
                ><h5>Presentación de la charla</h5></v-btn
            >
        </v-container>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        // Sin enlace no se pinta el iframe ni el boton: mostrar un respaldo
        // haria parecer que el enlace guardado no se aplico.
        videoUrl: null,
        presentacionUrl: null,
    }),
    created() {
        // Se usa axios pelado y NO tablesService: ese adjunta siempre
        // `Authorization: Bearer <token>`, y sin sesion el token es null. El
        // backend intenta validar ese "null", la autenticacion falla y responde
        // 401 sin llegar a mirar que el endpoint es publico. Esta pantalla se
        // muestra en el inicio, antes de iniciar sesion, asi que la peticion
        // tiene que ir sin credenciales. Mismo patron que info_proceso.vue.
        //
        // Se pide la lista entera y no cada clave por separado: los dos enlaces
        // se pintan juntos, asi que una sola peticion los trae a ambos.
        axios
            .get(`${process.env.VUE_APP_API_URL}/recursoinfoproceso/`)
            .then((respuesta) => {
                const recursos = respuesta.data || [];
                this.videoUrl = this.urlDe(recursos, "video_charla_practicas");
                this.presentacionUrl = this.urlDe(recursos, "presentacion_charla");
            })
            .catch((error) => {
                // El hueco ya se ve en pantalla; esto distingue "no hay fila"
                // de "fallo la peticion".
                console.error("No se pudieron cargar los enlaces de la charla", error);
            });
    },
    methods: {
        urlDe(recursos, clave) {
            const recurso = recursos.find((fila) => fila.clave === clave);
            return recurso && recurso.url ? recurso.url : null;
        },
        preguntas_url() {
            var show_logo=false;
            if (this.$route.path == "/"){
                show_logo=true;
            } 
            this.$router.push({ name: "Preguntas Frecuentes", params: { back_info: this.$route.path, show_logo: show_logo} });
        },
        info_proceso_url() {
            var show_logo=false;
            if (this.$route.path == "/"){
                show_logo=true;
            } 
            this.$router.push({ name: "Información del Proceso", params: { back_info: this.$route.path, show_logo: show_logo} });
        },
    },
};
</script>

<style>
.video-responsive {
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    padding-top: 30px;
    position: relative;
    border-radius: 10px;
    margin: 0 auto; /* Centra el video si es más pequeño que su contenedor */

}
.video-responsive iframe,
.video-responsive object,
.video-responsive embed {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    border-radius: 10px; 

}
</style>
